import * as Yup from 'yup';
import { t } from 'i18next';

export const DrawerSchema = () => Yup.object().shape({
    idCart: Yup.string()
        .required(t('validation.required')),
    dateOfIssue: Yup.string()
        .required(t('validation.required')),
});
